import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faInfo,
  faExclamationTriangle,
  faExclamation,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';

import Toast, { ToastProps } from 'react-bootstrap/Toast';
import React, { useContext } from 'react';
import { AlertContext } from './alert-provider';

import styled from 'styled-components';
import { AlertVariant } from '../types';

const variantToIconMap: { [key in AlertVariant]: IconDefinition } = {
  primary: faCheck,
  secondary: faInfo,
  success: faCheck,
  danger: faExclamationTriangle,
  warning: faExclamation,
  info: faInfo,
  light: faInfo,
  dark: faInfo,
};

const variantToColorCss: { [key in AlertVariant]: string } = {
  primary: 'color: #004085; background-color: rgba(204, 229, 255, 0.5);',
  secondary: 'color: #e2e3e5; background-color: rgba(226, 227, 229, 0.5);',
  success: 'color: #155724; background-color: rgba(212, 237, 218, 0.5);',
  danger: 'color: #721c24; background-color: rgba(248, 215, 218, 0.5);',
  warning: 'color: #856404; background-color: rgba(255, 243, 205, 0.5);',
  info: 'color: #0c5460; background-color: rgba(209, 236, 241, 0.5);',
  light: 'color: #818182; background-color: rgba(254, 254, 254, 0.5);',
  dark: 'color: #1b1e21; background-color: rgba(214, 216, 217, 0.5);',
};

const AlertsContainer = styled.div`
  z-index: 1000;

  @media (max-width: 991px) {
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
  }
  @media (min-width: 992px) {
    max-width: 960px;
    position: fixed;
    top: 4rem;
    right: 2rem;
    margin-left: 0;
    margin-right: 0;
  }
`;

const StyledToast = styled(Toast)`
  min-width: 275px;
  max-width: 275px;
  margin: 0;
  backdrop-filter: blur(2px);
`;

const StyledHeader = styled(Toast.Header)<{ variant: AlertVariant }>`
  ${(props): string => variantToColorCss[props.variant]};
`;

export const Alerts: React.FC<{ children?: React.ReactNode }> = () => {
  const { alerts, removeAlert } = useContext(AlertContext);

  return (
    <AlertsContainer>
      {alerts.map((alert) => {
        return (
          <StyledToast
            key={alert.key}
            onClose={(): void => removeAlert(alert.key)}
          >
            <StyledHeader variant={alert.variant}>
              <FontAwesomeIcon
                icon={variantToIconMap[alert.variant]}
                fixedWidth
                aria-hidden="true"
              />
              <strong className="mr-auto">{alert.content}</strong>
            </StyledHeader>
            {'body' in alert && <Toast.Body>{alert.body}</Toast.Body>}
          </StyledToast>
        );
      })}
    </AlertsContainer>
  );
};
